const IMAGES_BASE_URL = (
  import.meta.env.VITE_IMAGES_BASE_URL ?? 'https://images.blunticle.com'
).replace(/\/$/, '');

const GENERATION_IMAGE_NAME = 'image.png';

export function getGenerationImageUrl(generationId: string): string {
  return `${IMAGES_BASE_URL}/generations/${generationId}/${GENERATION_IMAGE_NAME}`;
}

export function resolveGenerationImageUrl(
  generationId: string,
  imageUrl: string | null,
): string | null {
  if (!imageUrl) return null;
  if (/^https?:\/\//i.test(imageUrl)) return imageUrl;
  return getGenerationImageUrl(generationId);
}
